"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// Taken from http://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/yaxis/type-log-negative/
var _default = function _default(H) {
  H.Axis.prototype.allowNegativeLog = true; // Override conversions

  H.Axis.prototype.log2lin = function (num) {
    var isNegative = num < 0;
    var adjustedNum = Math.abs(num);

    if (adjustedNum < 10) {
      adjustedNum += (10 - adjustedNum) / 10;
    }

    var result = Math.log(adjustedNum) / Math.LN10;
    return isNegative ? -result : result;
  };

  H.Axis.prototype.lin2log = function (num) {
    var isNegative = num < 0;
    var absNum = Math.abs(num);
    var result = Math.pow(10, absNum);

    if (result < 10) {
      result = 10 * (result - 1) / (10 - 1);
    }

    return isNegative ? -result : result;
  };
};

exports["default"] = _default;